
import React from 'react';
// Fix: Added missing 'Settings' icon to the lucide-react import
import { Award, History, Users, GraduationCap, Building2, Settings } from 'lucide-react';

const AboutPage: React.FC = () => {
  return (
    <div className="pb-24">
      {/* 40 Year Legacy */}
      <section className="py-24 container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="inline-flex p-3 bg-green-50 text-green-700 rounded-xl">
              <History size={24} />
            </div>
            <h1 className="text-5xl font-black text-slate-900 leading-tight">40 Years of <br /> Solar Mastery</h1>
            <p className="text-lg text-slate-600 leading-relaxed">
              Sun-farms (Suryamitra) isn't just a company; it's a legacy. Founded on the principles of engineering excellence and social responsibility, we have spent four decades bringing clean energy to Karnataka.
            </p>
            <p className="text-lg text-slate-600 leading-relaxed">
              Led by **Bettaswamy Gowda**, a recipient of the **Rastriya Ekatha Award**, our team combines deep technical knowledge with a commitment to national progress.
            </p>
            <div className="p-8 bg-slate-900 text-white rounded-[2.5rem] shadow-2xl">
               <div className="flex items-center gap-4 mb-4">
                 <Award className="text-yellow-400" size={32} />
                 <h4 className="text-xl font-bold uppercase tracking-widest">A National Legacy</h4>
               </div>
               <p className="text-sm opacity-70 italic">"Our goal has always been to make solar a livelihood, not just a product." — Bettaswamy Gowda</p>
            </div>
          </div>
          <div className="relative">
             <img 
                src="https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?auto=format&fit=crop&q=80&w=1000" 
                className="rounded-[3.5rem] shadow-2xl w-full aspect-[4/5] object-cover" 
                alt="Solar legacy" 
              />
              <div className="absolute top-10 -right-10 bg-white p-10 rounded-[2.5rem] shadow-2xl hidden xl:block border border-slate-100">
                 <div className="text-5xl font-black text-green-700">40</div>
                 <div className="text-xs font-bold uppercase tracking-widest text-slate-400 mt-2">Years In Solar</div>
              </div>
          </div>
        </div>
      </section>

      {/* Social Impact: Training */}
      <section className="py-24 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center mb-20">
            <div className="inline-flex p-4 bg-green-600 text-white rounded-2xl mb-8">
              <GraduationCap size={40} />
            </div>
            <h2 className="text-4xl font-black mb-6 uppercase tracking-tight">Suryamitra Training Initiative</h2>
            <p className="text-xl text-slate-500 leading-relaxed">
              We believe in the power of education. Sun-farms has successfully trained over **10,000 unemployed youths** free of cost, providing them with the certifications and skills to launch their own successful green energy ventures.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { 
                title: 'Skill Development', 
                icon: <Settings className="text-green-600" />,
                desc: 'Hands-on technical training on Topcon modules and hybrid inverters.' 
              },
              { 
                title: 'Business Mentorship', 
                icon: <Building2 className="text-green-600" />,
                desc: 'Guided support for setting up solar dealerships and service centers.' 
              },
              { 
                title: 'Job Placement', 
                icon: <Users className="text-green-600" />,
                desc: 'Connecting our graduates with industrial and commercial solar projects.' 
              }
            ].map((stat, i) => (
              <div key={i} className="bg-white p-10 rounded-[2.5rem] border border-slate-100 shadow-sm text-center">
                <div className="text-2xl font-bold mb-4">{stat.title}</div>
                <p className="text-slate-500 text-sm">{stat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sectors Served */}
      <section className="py-24 container mx-auto px-4">
         <div className="text-center mb-16">
            <h2 className="text-3xl font-black mb-2 uppercase tracking-tight">Sectors We Serve</h2>
            <p className="text-slate-500">Tailored engineering for every application.</p>
         </div>
         <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {['Residential', 'Commercial', 'Industrial', 'Institutions', 'Hotels', 'Resorts'].map((sector, i) => (
              <div key={i} className="p-6 bg-slate-50 rounded-2xl border border-slate-100 text-center hover:bg-green-600 hover:text-white transition-all cursor-default group">
                <span className="text-xs font-black uppercase tracking-widest">{sector}</span>
              </div>
            ))}
         </div>
      </section>
    </div>
  );
};

export default AboutPage;
